import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardSubtitle, CardText, CardTitle, Col, Row } from 'reactstrap';

import * as _ from 'lodash';
import * as moment from 'moment';

import './education.scss';

interface EducationComponentProps {
  degrees: any[];
}

class EducationComponent extends Component<EducationComponentProps, any> {
  constructor(props: any) {
    super(props);
    this.renderDegree = this.renderDegree.bind(this);
  }

  render() {
    return (
        <article role="education" id="education">
          <h2>Education</h2>
          <Row className="row-eq-height">
            {this.props.degrees.map(this.renderDegree)}
          </Row>
        </article>
    );
  }

  renderDegree(degree: any, index: number) {
    return (
        <Col md={4} sm={6} key={`edu-${index}`} className="mb-3">
          <Card>
            <CardBody>
              <header>
                <i className={`${degree.icon}`}/>
                <CardTitle>{degree.studyType}</CardTitle>
              </header>
              <article>
                <CardSubtitle>{degree.institution}, {this.formatDate(degree.endDate)}</CardSubtitle>
                <CardText>{degree.description}</CardText>
              </article>
            </CardBody>
          </Card>
        </Col>
    );
  }

  formatDate(date: moment.Moment): string {
    return `${date.format('MMMM YYYY')}`;
  }
}

const mapStateToProps = (state: any): EducationComponentProps => {
  return {
    degrees: _.get(state.cv, 'education.entries', [])
              .filter((it: any) => !it.hide)
              .map((it: any) => {
                if (it.endDate) {
                  it.endDate = moment(it.endDate);
                }

                return it;
              }),
  };
};

export default connect(mapStateToProps, null)(EducationComponent);



// WEBPACK FOOTER //
// ./src/components/education/education.component.tsx